module.exports = __webpack_public_path__ + "assets/hamburger-adcb41.svg";